import React, { useEffect, useState } from "react";
import {
    getManufacturedDevicesData, downloadManufacturedDevicesReport, updateProductSerialNumberbyID
} from "./../../action/report";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "./../layout/Alert";
import { setAlert } from "./../../action/alert";
import { connect } from "react-redux";
import { Fragment } from "react";
import SearchDevice from "./SearchDevice";
import Moment from "react-moment";
import customConfig from "../../config";
import { selectMenuProps } from "../../utils/selectMenuProps";
import {
    Box,
    Paper,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import EditIcon from "@mui/icons-material/Edit";
import MuiDatePicker from "../Common/FormInputs/MuiDatePicker";
import FormInput from "../Common/FormInputs/MuiTextField";
import Button from "../Common/Button/Button";
import AppIconButton from "../Common/Button/IconButton";
import DataTable from "../Common/DataTable/DataTable";
import IncrementalPagination from "../Common/DataTable/IncrementalPagination";
import { ACTION_BUTTON_HEIGHT } from "../../constants/uiConstants";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../theme/useDesignTokens";

const ManufacturedDevices = ({
    setCustomAlert,
    allowedDeviceCategories,
    updateProductSerialNumberbyID,
    updateSerialNumber,
    userRoleInfo
}) => {
    const theme = useTheme();
    const { colors } = useDesignTokens();
    const primaryColor = colors?.primary?.main || theme.palette.primary.main;
    const focusOutlineSx = {
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: `${primaryColor} !important`,
            borderWidth: "1px",
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: `${primaryColor} !important`,
        },
    };

    const headers = {
        deviceId: "Device Id",
        productSerialNumber: "Product Serial Number",
        manufacturedDate: "Manufactured Date",
        provisionedAt: "Provisioned At",
        onboardedAt: "OnBoarded At",
        modelNumber: "Model Number",
    };

    const [manufacturedDevicesData, setManufacturedDevicesData] = useState([]);
    const [categoryFilter, setCategoryFilter] = useState("");
    const [startDateFilter, setStartDateFilter] = useState(null);
    const [endDateFilter, setEndDateFilter] = useState(null);
    const [startSerialNumberFilter, setStartSerialNumberFilter] = useState("");
    const [endSerialNumberFilter, setEndSerialNumberFilter] = useState("");
    const [updateFlag, setUpdateFlag] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [lastApiPageFetched, setLastApiPageFetched] = useState(0);
    const [pageEndReached, setPageEndReached] = useState(false);
    const [showDeviceDetails, setShowDeviceDetails] = useState(false);
    const [selectedDeviceId, setSelectedDeviceId] = useState(undefined);
    const [showManufacturedDevicesList, setShowManufacturedDevicesList] = useState(false);
    const [newDeviceSerialNumber, setNewDeviceSerialNumber] = useState("");
    const [showUpdateDeviceSerialNoUI, setShowUpdateDeviceSerialNoUI] = useState(false);
    const [disabledDeviceSerialUpdateButton, setDisabledDeviceSerialUpdateButton] = useState(false);
    const today = new Date();

    const pageSize = 20;
    const totalPageCount = Math.ceil(manufacturedDevicesData?.length / pageSize);
    const startIndex = pageSize * currentPage;
    const endIndex = startIndex + pageSize;

    const handlePageChange = (newPage) => {
        if (newPage < 0) {
            return;
        }

        const loadedPageCount = Math.ceil(manufacturedDevicesData.length / pageSize);

        if (newPage < loadedPageCount) {
            setCurrentPage(newPage);
            return;
        }

        if (pageEndReached) {
            setCustomAlert("You have reached end of page.", "danger");
            return;
        }

        updateManufacturedDevciesData(
            lastApiPageFetched + 1,
            (data) => {
                if (data.length < 100) {
                    setPageEndReached(true);
                }

                if (data.length === 0) {
                    setCustomAlert("You have reached end of page.", "danger");
                    return;
                }

                setManufacturedDevicesData((prev) => [...prev, ...data]);
                setLastApiPageFetched((prev) => prev + 1);
                setCurrentPage(newPage);
            }
        );
    };

    const handlePageSizeChange = () => {
        // Page size is fixed to the current manufactured devices page size.
    };

    const formateDate = (dateFilter) => {
        if (dateFilter) {
            return dateFilter.getTime();
        }
    };

    const printableDate = (dateFilter) => {
        if (dateFilter) {
            const dateVal = dateFilter.getDate() < 10 ? `0${dateFilter.getDate()}` : dateFilter.getDate();
            const monthVal = dateFilter.getMonth() < 9 ? `0${dateFilter.getMonth() + 1}` : dateFilter.getMonth() + 1;
            return `${dateVal}-${monthVal}-${dateFilter.getFullYear()}`;
        }
    };

    const updateManufacturedDevciesData = (page, resolveFunc, errFunc) => {
        const categoryVal = categoryFilter === "" || categoryFilter === "Select Category" ? null : categoryFilter;
        if (!categoryVal || !startDateFilter) {
            return;
        }

        setIsLoading(true);

        let endDate = null;
        if (endDateFilter) {
            endDate = new Date(endDateFilter);
        }

        getManufacturedDevicesData({
            category: categoryVal,
            startDate: formateDate(startDateFilter),
            endDate: formateDate(endDateFilter ? new Date(endDate.setDate(endDate.getDate() + 1)) : endDateFilter),
            page: page || lastApiPageFetched,
            size: pageSize * 5,
            startSerialNumber: startSerialNumberFilter || undefined,
            endSerialNumber: endSerialNumberFilter || undefined,
        })
            .then((res) => {
                setIsLoading(false);
                if (!resolveFunc) {
                    if (res.length < 100) {
                        setPageEndReached(true);
                    }
                    setManufacturedDevicesData(res);
                } else {
                    resolveFunc(res);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                if (!errFunc) {
                    console.log(err);
                    setCustomAlert("Error while fetching data.", "danger");
                } else {
                    errFunc(err);
                }
            });
    };

    useEffect(() => {
        updateManufacturedDevciesData();
    }, [updateFlag]);

    useEffect(() => {
        const categoryVal = categoryFilter === "" || categoryFilter === "Select Category" ? null : categoryFilter;
        if (!categoryVal || !startDateFilter) {
            setShowManufacturedDevicesList(false);
        }
    }, [categoryFilter, startDateFilter]);

    useEffect(() => {
        if (!updateSerialNumber || (Array.isArray(updateSerialNumber) && updateSerialNumber.length === 0)) {
            return;
        }
        if (updateSerialNumber.hasOwnProperty("error")) {
            return;
        }
        setUpdateFlag(Math.random());
    }, [updateSerialNumber]);

    const reset = () => {
        setCategoryFilter("");
        setStartDateFilter(null);
        setEndDateFilter(null);
        setStartSerialNumberFilter("");
        setEndSerialNumberFilter("");
        setUpdateFlag(Math.random());
    };

    const filter = () => {
        const categoryVal = categoryFilter === "" || categoryFilter === "Select Category" ? null : categoryFilter;
        if (!categoryVal) {
            setCustomAlert("Category Cannot be Empty", "danger");
            return;
        }
        if (!startDateFilter) {
            setCustomAlert("Start Date Cannot be Empty", "danger");
            return;
        }
        if (!endDateFilter) {
            setCustomAlert("End Date Cannot be Empty", "danger");
            return;
        }
        if (new Date(startDateFilter).getTime() > new Date(endDateFilter).getTime()) {
            setCustomAlert("Start Date Cannot be greater than End Date", "danger");
            return;
        }

        setCurrentPage(0);
        setPageEndReached(false);
        setLastApiPageFetched(0);
        setUpdateFlag(Math.random());
        setShowManufacturedDevicesList(true);
    };

    const handleStartDateChange = (date) => {
        setStartDateFilter(date);
    };

    const handleEndDateChange = (date) => {
        setEndDateFilter(date);
    };

    const handleDownloadManufacturedDevcies = () => {
        const categoryVal = categoryFilter === "" || categoryFilter === "Select Category" ? null : categoryFilter;
        if (!categoryVal) return;
        if (!startDateFilter) return;
        if (startDateFilter && endDateFilter && startDateFilter > endDateFilter) {
            setCustomAlert("Start Date Cannot be greater than End Date", "danger");
            return;
        }

        let endDate = null;
        if (endDateFilter) {
            endDate = new Date(endDateFilter);
        }

        downloadManufacturedDevicesReport({
            category: categoryVal,
            startDate: formateDate(startDateFilter),
            endDate: formateDate(endDateFilter ? new Date(endDate.setDate(endDate.getDate() + 1)) : endDateFilter),
            startSerialNumber: startSerialNumberFilter || undefined,
            endSerialNumber: endSerialNumberFilter || undefined,
            printableStartDate: printableDate(startDateFilter),
        });
    };

    const showUpdateDeviceSerialPopup = (deviceSerialNumber) => {
        const serialNo = deviceSerialNumber ? String(deviceSerialNumber).trim() : "";
        setNewDeviceSerialNumber(serialNo);
        setDisabledDeviceSerialUpdateButton(serialNo.length <= 0);
        setShowUpdateDeviceSerialNoUI(!showUpdateDeviceSerialNoUI);
    };

    const onChangeDeviceSerialNumber = (e) => {
        const val = e.target.value;
        setDisabledDeviceSerialUpdateButton(!val || val.trim().length <= 0);
        setNewDeviceSerialNumber(val);
    };

    const updateDeviceSerialNumber = (deviceId) => {
        const updatedDeviceSerialNo = newDeviceSerialNumber ? String(newDeviceSerialNumber).trim() : "";
        if (updatedDeviceSerialNo) {
            updateProductSerialNumberbyID(deviceId, updatedDeviceSerialNo);
            setShowUpdateDeviceSerialNoUI(false);
        }
    };

    const cancelDeviceSerialPopup = () => {
        setShowUpdateDeviceSerialNoUI(false);
        setDisabledDeviceSerialUpdateButton(false);
    };

    const canEditSerial = userRoleInfo?.level > 1 || (userRoleInfo?.level > 1 && userRoleInfo?.roles?.includes(customConfig.roleFactoryAdmin));

    const manufacturedDeviceColumnConfig = {
        deviceId: { width: 170, minWidth: 170 },
        productSerialNumber: { width: 260, minWidth: 240 },
        manufacturedDate: { width: 170, minWidth: 170 },
        provisionedAt: { width: 170, minWidth: 170 },
        onboardedAt: { width: 170, minWidth: 170 },
        modelNumber: { width: 190, minWidth: 180 },
    };

    const manufacturedDeviceColumns = Object.keys(headers).map((key) => ({
        key,
        label: headers[key],
        width: manufacturedDeviceColumnConfig[key]?.width,
        minWidth: manufacturedDeviceColumnConfig[key]?.minWidth,
        headerCellSx: {
            backgroundColor: "#f5f5f5",
            padding: "12px 12px",
        },
        cellSx: {
            whiteSpace:
                key === "productSerialNumber" || key === "modelNumber"
                    ? "normal"
                    : "nowrap",
            verticalAlign: "middle",
            padding: "10px 12px",
        },
        render: (val, row) => {
            const strVal = String(val || "");
            const isLong = strVal.length > 200;
            const contentSx = {
                whiteSpace:
                    key === "productSerialNumber" || key === "modelNumber"
                        ? "normal"
                        : "nowrap",
                wordBreak: isLong ? "break-all" : "normal",
            };

            if (key === "manufacturedDate" || key === "provisionedAt" || key === "onboardedAt") {
                return strVal && strVal.length > 0 ? (
                    <Box sx={contentSx}>
                        <Moment format="DD-MM-YYYY HH:mm:ss" date={val * 1000} />
                    </Box>
                ) : (
                    ""
                );
            }

            if (key === "productSerialNumber") {
                return selectedDeviceId === row.deviceId && showUpdateDeviceSerialNoUI ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "flex-start" }}>
                        <FormInput
                            placeholder="Enter Serial Number"
                            value={newDeviceSerialNumber}
                            onChange={(e) => onChangeDeviceSerialNumber(e)}
                            size="small"
                            sx={{ width: "100%", maxWidth: 240, "& .MuiOutlinedInput-root": { height: 36 } }}
                        />
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                                variant="primary"
                                size="small"
                                disabled={disabledDeviceSerialUpdateButton}
                                onClick={() => updateDeviceSerialNumber(row.deviceId)}
                            >
                                Update
                            </Button>
                            <Button variant="ghost" size="small" onClick={cancelDeviceSerialPopup}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                ) : (
                    <Box sx={{ ...contentSx, display: "flex", alignItems: "center" }}>
                        <Box component="span">{val || ""}</Box>
                        {canEditSerial && (
                            <AppIconButton
                                size="small"
                                variant="primary"
                                onClick={() => {
                                    setSelectedDeviceId(row.deviceId);
                                    showUpdateDeviceSerialPopup(val);
                                }}
                                icon={<EditIcon sx={{ fontSize: 18 }} />}
                                tooltip="Edit serial number"
                                aria-label="Edit serial number"
                                sx={{
                                    ml: 0.5,
                                    color: primaryColor,
                                    "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
                                }}
                            />
                        )}
                    </Box>
                );
            }

            if (key === "deviceId") {
                return (
                    <Box
                        component="span"
                        sx={{ ...contentSx, cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => {
                            setSelectedDeviceId(row.deviceId);
                            setShowDeviceDetails(true);
                        }}
                    >
                        {val || ""}
                    </Box>
                );
            }

            return <Box sx={contentSx}>{val || ""}</Box>;
        },
    }));

    if (isLoading && manufacturedDevicesData.length === 0) {
        return (
            <Box sx={{ display: "grid", placeItems: "center", height: "80vh" }}>
                <CircularProgress size="5em" sx={{ color: primaryColor || "#AFB42B" }} />
            </Box>
        );
    }

    return (
        <Fragment>
            {!showDeviceDetails && (
                <Box sx={{ width: "100%", maxWidth: "100%", mx: 0, boxSizing: "border-box", minWidth: 0 }}>
                    <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
                        <Box sx={{ pt: 1, pb: 1.5, px: 0 }}>
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "1fr",
                                        sm: "repeat(2, minmax(0, 1fr))",
                                        lg: "repeat(5, minmax(180px, 1fr))",
                                    },
                                    gap: 2,
                                    mb: 0,
                                    alignItems: "center",
                                }}
                            >
                                <FormInput
                                    type="select"
                                    size="small"
                                    fullWidth
                                    name="categoryFilter"
                                    value={categoryFilter || ""}
                                    onChange={(e) => setCategoryFilter(e.target.value)}
                                    options={[
                                        { value: "", label: "Select Category" },
                                        ...(allowedDeviceCategories || []).map((element) => ({
                                            value: element,
                                            label: element,
                                        })),
                                    ]}
                                    displayEmpty
                                    renderValue={(v) => v || "Select Category"}
                                    MenuProps={selectMenuProps}
                                />
                                <MuiDatePicker
                                    label="Start Date"
                                    value={startDateFilter}
                                    maxDate={endDateFilter || today}
                                    onChange={handleStartDateChange}
                                />
                                <MuiDatePicker
                                    label="End Date"
                                    value={endDateFilter}
                                    minDate={startDateFilter || undefined}
                                    maxDate={today}
                                    onChange={handleEndDateChange}
                                />
                                <FormInput
                                    placeholder="Start Serial Number"
                                    name="startSerialNumber"
                                    value={startSerialNumberFilter}
                                    onChange={(e) => setStartSerialNumberFilter(e.target.value)}
                                    size="small"
                                />
                                <FormInput
                                    placeholder="End Serial Number"
                                    name="endSerialNumber"
                                    value={endSerialNumberFilter}
                                    onChange={(e) => setEndSerialNumberFilter(e.target.value)}
                                    size="small"
                                />
                            </Box>
                            <Grid2 container spacing={2} alignItems="center" sx={{ mt: 0 }}>
                                <Grid2 size={12}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: { xs: 1, sm: 2 },
                                            flexWrap: { xs: "wrap", sm: "nowrap" },
                                            pt: 1.5,
                                            overflowX: { xs: "visible", sm: "auto" },
                                        }}
                                    >
                                        <Button
                                            variant="primary"
                                            onClick={filter}
                                            sx={{
                                                minWidth: { xs: 0, sm: 100 },
                                                width: { xs: "calc(50% - 4px)", sm: "auto" },
                                                flexShrink: 0,
                                            }}
                                        >
                                            Filter
                                        </Button>
                                        <Button
                                            variant="ghost"
                                            onClick={reset}
                                            sx={{
                                                minWidth: { xs: 0, sm: 100 },
                                                width: { xs: "calc(50% - 4px)", sm: "auto" },
                                                flexShrink: 0,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                        <Button
                                            variant="primary"
                                            onClick={handleDownloadManufacturedDevcies}
                                            sx={{
                                                minWidth: { xs: 0, sm: 100 },
                                                width: { xs: "100%", sm: "auto" },
                                                flexShrink: 0,
                                            }}
                                        >
                                            Download
                                        </Button>
                                    </Box>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </Paper>
                    <Alert />

                    {showManufacturedDevicesList && (
                        <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
                            <Box
                                className="manufactured-devices-table-scroll"
                                sx={{
                                    width: "100%",
                                    minWidth: 0,
                                    overflowX: { xs: "auto", lg: "hidden" },
                                    overflowY: "hidden",
                                    WebkitOverflowScrolling: "touch",
                                }}
                            >
                                <DataTable
                                    columns={manufacturedDeviceColumns}
                                    data={manufacturedDevicesData.slice(startIndex, endIndex)}
                                    rowKey="deviceId"
                                    minWidth={{ xs: 1120, lg: "100%" }}
                                    sx={{
                                        "& table": {
                                            tableLayout: { xs: "auto", lg: "fixed" },
                                            minWidth: { xs: 1120, lg: "100%" },
                                            width: { xs: "max-content", lg: "100%" },
                                        },
                                    }}
                                    tableContainerSx={{
                                        boxShadow: "none",
                                        borderRadius: 1,
                                        width: { xs: "max-content", lg: "100%" },
                                        minWidth: { xs: 1120, lg: "100%" },
                                        border: "1px solid",
                                        borderColor: "divider",
                                    }}
                                    msgForDisplay="No Data found"
                                    maxHeight = "calc(100dvh - 354px)"
                                />
                            </Box>
                            <IncrementalPagination
                                page={currentPage}
                                pageSize={pageSize}
                                dataLength={manufacturedDevicesData.length}
                                onPageChange={handlePageChange}
                                onPageSizeChange={handlePageSizeChange}
                                pageSizeOptions={[pageSize]}
                                isLastPage={pageEndReached && endIndex >= manufacturedDevicesData.length}
                                sx={{ m: 0, mt: 1.5, px: 0 }}
                            />
                        </Paper>
                    )}
                </Box>
            )}

            {showDeviceDetails && (
                <Box sx={{ width: "100%", pb: 1.5 }}>
                    <Box sx={{ mb: 1.5 }}>
                        <Button variant="primary" size="medium" onClick={() => { setShowDeviceDetails(false); setSelectedDeviceId(null); }}>
                            Back
                        </Button>
                    </Box>
                    <SearchDevice deviceId={selectedDeviceId} embedded />
                </Box>
            )}
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    updateSerialNumber: state.report.updateSerialNumber,
    userRoleInfo: {
        level: state.auth.userLevel,
        roles: state.auth.userRoles,
    },
});

const mapDispatchToProps = (dispatch) => ({
    setCustomAlert: (message, alertType) => dispatch(setAlert(message, alertType)),
    updateProductSerialNumberbyID: (deviceId, productSerialNumber) =>
        dispatch(updateProductSerialNumberbyID(deviceId, productSerialNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManufacturedDevices);
